var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleDownFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feature/system/icTriangleDownFill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5997C11.6222 15.5997 11.2666 15.4219 11.04 15.1197L7.43996 10.3197C7.16724 9.9561 7.12338 9.4696 7.32665 9.06306C7.52992 8.65652 7.94543 8.39972 8.39996 8.39972H15.5999C16.0545 8.39972 16.47 8.65652 16.6733 9.06306C16.8765 9.4696 16.8327 9.9561 16.5599 10.3197L12.9599 15.1197C12.7333 15.4219 12.3777 15.5997 12 15.5997Z",
    fill: "#5D6BDD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDownFill);
export default __webpack_public_path__ + "static/media/triangle-down-fill.9acab31ec78eaf4f568abc34a702097e.svg";
export { ForwardRef as ReactComponent };